<template>
  <q-layout view="hHh Lpr fFf" class="overflow-hidden bg-[#fafbfb]">
    <main>
      <router-view></router-view>
    </main>
  </q-layout>
</template>

<script setup>
import { Dark } from 'quasar'
import useIframeParams from 'composables/useIframeParams'

Dark.set(false)
useIframeParams()
</script>

<style lang="sass" scoped></style>
